<template>
    <common-page flex-column card-content>
        <mini-table ref="_miniTable" read-only
                    enable-inline-edit
                    :items="enumList"
                    :fields="tableFields"
                    :loading="queryLoading"
                    no-require-warning
                    filterable>
            <template #rightHeader>
                <mini-button :loading="queryLoading" @btnClick="getRemoteData">
                    <i class="fa-solid fa-rotate-right"></i>
                </mini-button>
                <mini-button :loading="saveLoading" @btnClick="doSave">
                    保存
                </mini-button>
            </template>

        </mini-table>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

const ENTITY = 'emDictType';

export default {
    name: "DictionaryGroupEdit",
    mixins: [emCommonUtilMixin],
    components: {MiniButton, MiniTable, CommonPage},
    data() {
        return {
            enumList: [],
            queryLoading: false,
            saveLoading: false,
        }
    },
    computed: {
        tableFields() {
            return [
                {key: 'dictGroup', label: 'Group(自动作为Code的前缀)', require: true},
                {key: 'dictType', label: 'Code', require: true},
                {key: 'dictName', label: 'Name', require: true},
                {key: 'remark', label: 'Remark'},
            ]
        },
    },
    mounted() {
        this.getRemoteData();
    },
    methods: {
        getRemoteData() {
            this.queryLoading = true;
            this.$store.dispatch('api/get', {
                url: `${this._baseUrl(ENTITY)}/simple/queryAll`
            }).then(res => {
                this.enumList = res;
            }).finally(() => this.queryLoading = false);
        },
        doSave() {
            let obj = this.$refs._miniTable.collectInlineEditData();
            if (obj.deleteIds && obj.deleteIds.length > 0 || obj.editRows && obj.editRows.length > 0) {
                if (obj.editRows && obj.editRows.length > 0 && !this.$refs._miniTable.isInputCompete()) {
                    this.$message.warning("不能为空")
                    return;
                }
                this.saveLoading = true;
                this.$store.dispatch('api/post', {
                    url: `${this._baseUrl(ENTITY)}/simple/edit`,
                    data: obj
                }).then(() => {
                    this.$message.success("保存成功");
                    this.getRemoteData();
                }).finally(() => this.saveLoading = false);
            } else {
                this.$message.warning("没有修改需要保存");
            }
        },
    }
}
</script>

<style scoped>

</style>
